import React, { Component } from 'react';
import PromptSet from 'components/Prompt/PromptSet.js';
import { Item, Grid } from 'semantic-ui-react'
import './ImpactSpace.sass';

class ImpactSpace extends Component {
	render() {
		const config = this.props.config;

		return (
			<div className="impactSpace" id={config.id}>
				<Item.Group relaxed>
					<Item>

						<Item.Content>
							<Item.Header as='h2'>{config.title}</Item.Header>
							<Item.Description>
								{config.description}
							</Item.Description>
						</Item.Content>
						<Item.Image className="logo" size='medium' src={config.logo} />
					</Item>
				</Item.Group>

				<Grid stackable columns={config.numCols || 2}>
					{
						config.promptSets.map((el, idx) =>
							<Grid.Column key={idx}>
								<PromptSet title={el.title} prompts={el.prompts} resources={el.resources} key={idx}/>
							</Grid.Column>
						)
					}
				</Grid>
			</div>
		);
	}
}

export default ImpactSpace;
